/* eslint-disable camelcase */
import L from 'leaflet';
import styles from './map.module.scss';

const CustomIcon = L.DivIcon.extend({
  createIcon() {
    const icon = L.DivIcon.prototype.createIcon.call(this);
    icon.style.backgroundColor = this.options.color;
    icon.style.border = '2px solid #E7F2FC';
    icon.style.borderRadius = '50%';
    return icon;
  }
});

const IconImage = L.DivIcon.extend({
  createIcon() {
    const icon = L.DivIcon.prototype.createIcon.call(this);
    icon.style.backgroundImage = `url(${this.options.icon})`;
    icon.style.width = '30px';
    icon.style.height = '15px';
    icon.style.backgroundSize = 'contain';
    icon.style.backgroundPosition = 'center';
    // icon.style.cursor = 'none';
    icon.style.backgroundRepeat = 'no-repeat';
    icon.style.backgroundColor = 'transparent';
    // icon.style.border = 'none';
    return icon;
  }
});

const toggleZooming = (map, action) => {
  map.dragging[action]();
  map.touchZoom[action]();
  map.doubleClickZoom[action]();
  map.scrollWheelZoom[action]();
  map.boxZoom[action]();
  map.keyboard[action]();
};

const addPopupToLayer = (surface, layer) => {
  const { surface_type: { name, color } } = surface;
  const customPopup = `
    <div class=${styles.tooltipHeader}>
        <h4>${surface.name}</h4>
        <a href="/#"> view details </a>
    </div>   
    <p>${name}</p>
  `;
  // specify popup options
  const customOptions = { className: styles.tooltip, width: '200' };
  const customlayer = layer.bindPopup(customPopup, customOptions);

  customlayer.setStyle({
    fillColor: color,
    color,
    opacity: 1,
    fillOpacity: 0.48
  });

  return customlayer;
};

const disableEditMarkers = (map) => {
  // Disable editing marker if any
  map.eachLayer((layer) => {
    if (layer.editing && layer.editing.enabled()) {
      layer.editing.disable();
    }
  });
};

const azerbaijaniDrawLocale = {
  'draw': {
      'toolbar': {
          'actions': {
              'title': 'Rəsmi ləğv edin',
              'text': 'Ləğv et'
          },
          'finish': {
              'title': 'Rəsmi bitirin',
              'text': 'Bitir'
          },
          'undo': {
              'title': 'Son çəkilmiş nöqtəni silin',
              'text': 'Son nöqtəni silin'
          },
          'buttons': {
              'polyline': 'polyline çəkmək üçün bunun üzərinə klikləyin',
              'polygon': 'poliqon çəkmək üçün bunun üzərinə klikləyin',
              'rectangle': 'Bir düzbucaqlı çəkin',
              'circle': 'Bir dairə çəkin',
              'marker': 'marker qoymaq üçün bunun üzərinə klikləyin',
              'circlemarker': 'Dairə işarəsi çəkin'
          }
      },
      'handlers': {
          'circle': {
              'tooltip': {
                  'start': 'Dairə çəkmək üçün klikləyin və dartın.'
              },
              'radius': 'Radius'
          },
          'circlemarker': {
              'tooltip': {
                  'start': 'Dairə markerini yerləşdirmək üçün xəritəyə klikləyin.'
              }
          },
          'marker': {
              'tooltip': {
                  'start': 'Markeri yerləşdirmək üçün xəritəyə klikləyin.'
              }
          },
          'polygon': {
              'tooltip': {
                  'start': 'Formanı çəkməyə başlamaq üçün klikləyin.',
                  'cont': 'Formanı çəkməyə davam etmək üçün klikləyin.',
                  'end': 'Bu formanı bağlamaq üçün birinci nöqtəyə klikləyin.'
              }
          },
          'polyline': {
              'error': '<strong>Xəta:</strong> forma kənarları keçə bilməz!',
              'tooltip': {
                  'start': 'Xətt çəkməyə başlamaq üçün klikləyin.',
                  'cont': 'Xətti çəkməyə davam etmək üçün klikləyin.',
                  'end': 'Xətti bitirmək üçün son nöqtəyə klikləyin.'
              }
          },
          'rectangle': {
              'tooltip': {
                  'start': 'Düzbucaqlı çəkmək üçün klikləyin və dartın.'
              }
          },
          'simpleshape': {
              'tooltip': {
                  'end': 'Rəsmi bitirmək üçün siçanı buraxın.'
              }
          }
      }
  },
  'edit': {
      'toolbar': {
          'actions': {
              'save': {
                  'title': 'Dəyişiklikləri yadda saxlayın.',
                  'text': 'Saxla'
              },
              'cancel': {
                  'title': 'Redaktəni ləğv edin, bütün dəyişiklikləri rədd edir.',
                  'text': 'Ləğv et'
              },
              'clearAll': {
                  'title': 'Bütün təbəqələri təmizləyin.',
                  'text': 'Hamısını Sil'
              }
          },
          'buttons': {
              'edit': 'Qatları redaktə edin.',
              'editDisabled': 'Redaktə etmək üçün təbəqə yoxdur.',
              'remove': 'Qatları silin.',
              'removeDisabled': 'Silinəcək qat yoxdur.'
          }
      },
      'handlers': {
          'edit': {
              'tooltip': {
                  'text': 'Funksiyanı redaktə etmək üçün tutacaqları və ya markeri dartın.',
                  'subtext': 'Dəyişiklikləri ləğv etmək üçün Ləğv et klikləyin.'
              }
          },
          'remove': {
              'tooltip': {
                  'text': 'Silmək üçün funksiyaya klikləyin'
              }
          }
      }
  }
};

export {
  CustomIcon,
  addPopupToLayer,
  toggleZooming,
  IconImage,
  disableEditMarkers,
  azerbaijaniDrawLocale
};
